import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { CountryService, ECountry, isRestrictedCountry } from 'country-service';
import { catchError, defaultIfEmpty, filter, map, of, take } from 'rxjs';

export const geoBlockGuard: CanActivateFn = () => {
  const countryService = inject(CountryService);
  const router = inject(Router);

  return countryService.countryCode$.pipe(
    filter((code) => !!code),
    defaultIfEmpty(ECountry.ALL),
    map((code) => (isRestrictedCountry(code as ECountry) ? router.createUrlTree(['/store']) : true)),
    catchError(() => of(router.createUrlTree(['/store']))),
    take(1),
  );
};
